import { HookFormProvider, HookFormProviderProps } from "../HookForm/Provider";
import { HookForm } from "../HookForm/Form";
import React from "react";
export interface JsonFormProps {
  onSubmit: (values: any) => Promise<void> | void;
  hookFormProviderProps?: Omit<HookFormProviderProps, "children">;
  children?: React.ReactNode;
  formClassName?: string;
}

export const JsonForm = (props: JsonFormProps) => {
  const { onSubmit, hookFormProviderProps, children, formClassName } = props;
  return (
    <HookFormProvider {...hookFormProviderProps}>
      <HookForm onSubmit={onSubmit} className={formClassName} noValidate>
        <div className="grid grid-cols-12 gap-4 w-full h-full content-between">
          {children}
        </div>
      </HookForm>
    </HookFormProvider>
  );
};
